import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useState } from "react";
import CdadHeaderFilterVehicleTab from "../CdadHeaderFilterVehicleTab";
import VehicleFilter from "./components/vehicleFilter";
import ProductionFacility from "./components/productionFacility";
import PartsFilter from "./components/partsFilter";

dayjs.extend(utc);

const CdadHeaderVehicleFilterComponent = (props: any) => {
    const {
        vinList,
        getUpdatedList,
        vinListFile,
        vehicleName,
        modelYear,
        dispatchModelType,
        plantName,
        lineOffDate, naOverseas, engineTypeCode, engineFamilyCode, powerTrainType, driveTrainCategory, transmissionType, transmissionModel, partNumber, partName,
        unNestedParamData,
        vinListFromFile,
        familyCd,
        odometerMin,
        odometerMax
    } = props;
    const [vehicleFilterCurrentTab, setVehicleFilterCurrentTab] = useState<any>(0);

    return (
        <div style={{ display: "flex" }}>
            <CdadHeaderFilterVehicleTab setVehicleFilterCurrentTab={setVehicleFilterCurrentTab} />
            <div style={{ display: "flex", flexWrap: "wrap", paddingTop: "1rem", justifyContent: "flex-start" }}>
                {vehicleFilterCurrentTab === 0 ?
                    <VehicleFilter
                        getUpdatedList={getUpdatedList} vinListFile={(value: any) => vinListFile(value)} modelYear={modelYear} familyCd={familyCd} dispatchModelType={dispatchModelType} vehicleName={vehicleName} vinList={vinList}
                        unNestedParamData={unNestedParamData}
                        vinListFromFile={vinListFromFile}
                        odometerMin={odometerMin}
                odometerMax={odometerMax}
                    />
                    : vehicleFilterCurrentTab === 1 ?
                        <ProductionFacility
                            getUpdatedList={getUpdatedList}
                            unNestedParamData={unNestedParamData}
                            plantName={plantName}
                            lineOffDate={lineOffDate}
                        />
                        :
                        <PartsFilter
                            getUpdatedList={getUpdatedList}
                            naOverseas={naOverseas}
                            engineTypeCode={engineTypeCode}
                            engineFamilyCode={engineFamilyCode}
                            powerTrainType={powerTrainType}
                            driveTrainCategory={driveTrainCategory}
                            transmissionType={transmissionType}
                            transmissionModel={transmissionModel}
                            partNumber={partNumber}
                            partName={partName}
                            unNestedParamData={unNestedParamData}
                            vinListFromFile={vinListFromFile} />
                }
            </div>
        </div>
    );
};



export default CdadHeaderVehicleFilterComponent;
